/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate pixels per inch from resolution and screen size.`)
};

const es_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula los píxeles por pulgada a partir de la resolución y el tamaño de pantalla.`)
};

const de_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne Pixel pro Zoll (PPI) aus Auflösung und Bildschirmgröße.`)
};

const nl_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken pixels per inch op basis van resolutie en schermgrootte.`)
};

const fr_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez les pixels par pouce à partir de la résolution et de la taille d'écran.`)
};

const it_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola i pixel per pollice da risoluzione e dimensione dello schermo.`)
};

const pt_br2_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule pixels por polegada a partir da resolução e do tamanho da tela.`)
};

const pt_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule os pixels por polegada a partir da resolução e do tamanho do ecrã.`)
};

const ja_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解像度と画面サイズから1インチあたりのピクセル数を計算します。`)
};

const zh_ppi_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据分辨率和屏幕尺寸计算每英寸像素数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_tool_description", locale)
	if (locale === "en") return en_ppi_tool_description(inputs)
	if (locale === "es") return es_ppi_tool_description(inputs)
	if (locale === "de") return de_ppi_tool_description(inputs)
	if (locale === "nl") return nl_ppi_tool_description(inputs)
	if (locale === "fr") return fr_ppi_tool_description(inputs)
	if (locale === "it") return it_ppi_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_tool_description(inputs)
	if (locale === "pt") return pt_ppi_tool_description(inputs)
	if (locale === "ja") return ja_ppi_tool_description(inputs)
	return zh_ppi_tool_description(inputs)
};